import { PerfilamientoMasterRespuestaPadreHija } from "./perfilamientoMasterPadreHija";
import { PerfilamientoMasterProcesosSeguimiento } from "./perfilamientoMasterProcesosSeguimiento";
import { PerfilamientoMasterProyectoComprado } from "./perfilamientoMasterProyectoComprado";

export class PerfilamientoMaster {
  idPerfilamientoMaster?: number = -1;
  idSeguimientoProspecto?: number = -1;
  idProyecto?: number;
  idProspecto?: number = 0;
  citaAsistida?: number = -1;
  mas_informacion?: number = -1;
  compra_para?: number = -1;
  presupuesto?: number = -1;
  idAsesor?: number = -1;
  estatus?: string = "";
  idUsuarioUM?: number = -1;
  fechaHoraUM?: Date;
  cantidad_banos?: number = 0;
  cantidad_recamaras?: number = 0;
  planta_baja?: number = 0;
  comentarios?: string = "";
  perfilamientoMasterProyectoComprado: PerfilamientoMasterProyectoComprado;
  perfilamientoMasterRespuestaPadreHija: PerfilamientoMasterRespuestaPadreHija[];
  perfilamientoMasterProcesosSeguimiento: PerfilamientoMasterProcesosSeguimiento[] = [];
  conCita?: number = 0;
  calificacion_asesor?: number = 0;
  tipo_distribuccion?: number = -1;
  tipo_credito?: number = -1;
  mensualidad_Pago?: number = 0;
  ciudad?: number = 0;
  distribuccionString?: string = "";
  ciudadString?: string = "";
  preventaEntrega?: number = -1; //1 Preventa 2 Entrega inmediata
  descripcionEnfoqueVida?: string = "";
  //FiltroInterno
  proyecto?: number = 0;
  cita?: boolean = false;
  strike?: boolean = false;
  operado?: number = 0;
  aliado?: number = 0;
}
